"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./avatar.scss");
const AvatarIcon = require('../../../../../assets/images/svg/image-removebg-preview.svg');
const common_1 = require("../../../../../utils/common");
const Avatar = (props) => {
    const { directoryType, uid } = props;
    const _target = !common_1.ifMobile() ? '_blank' : '_self';
    return (react_1.default.createElement("a", { className: `experts-avatar-wrapper`, target: _target, href: `#/directory/${directoryType == 'experts' ? 'expertsProfile' : 'servicesProfile'}?uid=${uid}` },
        react_1.default.createElement("img", { alt: props.name, className: `${props.imageUrl ? 'avatar' : 'default-avatar'}`, src: props.imageUrl ? props.imageUrl : AvatarIcon.default })));
};
exports.default = Avatar;
